"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Progress = Progress;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function Progress(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? '1rem' : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'secondary' : _ref$color;
  return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    alignItems: "center",
    alignContent: "center",
    justifyContent: "center"
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react["default"].createElement(_material.CircularProgress, {
    size: size,
    color: color
  })));
}